export const headTableCells = [
  { id: 1, property: '', label: '' },
  { id: 2, property: 'Title', label: 'Title' },
  { id: 3, property: 'CustomerName', label: 'Customer' },
  { id: 4, property: 'StatusTitle', label: 'Status' },
  { id: 5, property: 'ConsultantName', label: 'Consultant' },
  { id: 6, property: 'UpdatedOn', label: 'Updated' },
];
